import React, {useEffect, useState} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'datatables.net-dt/css/jquery.dataTables.min.css';
import 'datatables.net-dt/js/dataTables.dataTables';
import 'jquery/dist/jquery.min.js';
import '../../Styles/Annotator/AdvicesComponent.css';
//import { createColumnHelper } from "@tanstack/react-table";
import SummaryComponent from "./SummaryComponent";

//import {Trash2} from "react-feather";

function ShowSummaryComponent(props) {
    const [summaryData, setSummaryData] = useState([]);
    const [columns, setColumns] = useState([]);

    console.log(typeof props.setAnnotationData, "summary")


    //     const handleDelete = async (o, state, setAnnotations) => {
    //     removingAnnotation(o.unique_id, props.annotationData)
    //     let newData = state.annotations.filter((obj) => obj.unique_id !== o.unique_id);
    //     let newState = state
    //     newState.annotations = newData
    //     setAnnotations(newState);
    //     // Create a new array without the object to delete
    //     // let annotations = await updatedState
    //     // console.log(annotations, "handle")
    //     // console.log(state, "lamba")
    //     // This should log the updated array correctly
    //     // let newState = state
    //     // newState.annotations = annotations
    //     // console.log(typeof setAnnotations, "+")
    //     // setAnnotations(newState);
    //     // Update the state with the new array
    // }


    useEffect(async () => {
        /**let annotationsGet = await getAllAnnotationsDB().then(function (result) {
         return JSON.stringify(result);
         });**/



            // let columnHelper = createColumnHelper();
            // setColumns([
            //     columnHelper.accessor("ord", {
            //         // eslint-disable-next-line react/react-in-jsx-scope
            //         cell: (info) => <b>{info.getValue()}</b>,
            //         // eslint-disable-next-line react/react-in-jsx-scope
            //         header: () => <span>OZ</span>
            //     }),
            //     columnHelper.accessor("adviceID", {
            //         // eslint-disable-next-line react/react-in-jsx-scope
            //         cell: (info) => <b>{info.getValue()}</b>,
            //         // eslint-disable-next-line react/react-in-jsx-scope
            //         header: () => <span>Advice ID</span>
            //     }),
            //     columnHelper.accessor("Annotation", {
            //         cell: (info) => <b>{info.getValue()}</b>,
            //         header: () => <span>Annotation</span>
            //     }),
            //     columnHelper.accessor("short_text", {
            //         // eslint-disable-next-line react/react-in-jsx-scope
            //         header: () => <span>Kurztext</span>
            //     }),
            //     columnHelper.accessor("norm", {
            //         // eslint-disable-next-line react/react-in-jsx-scope
            //         header: () => <span>AI Tag</span>
            //     }),
            //     columnHelper.accessor("unique_id", {
            //                         // cell: (info) => <b><button onClick={
            //                         //                 () => handleDelete(info,props.annotationData,props.setAnnotationData)
            //                         //             }><Trash2/></button></b>,
            //         // eslint-disable-next-line react/react-in-jsx-scope
            //         header: () => <span>Aktion</span>
            //     })
            // ])


        const columns = [
                {
                    Header: 'OZ',
                    accessor: 'ord'
                },
                {
                    Header: 'Advice ID',
                    accessor: 'adviceID'
                },
                {
                    Header: 'Annotation',
                    accessor: 'Annotation'
                },
                {
                    Header: 'Kurztext',
                    accessor: 'short_text'
                },
                {
                    Header: 'AI Tag',
                    accessor: 'norm'
                },
                {
                    Header: 'Aktion',
                    accessor: 'unique_id'
                }
            ];
        setColumns(columns)


        let annotations = props.annotationData.annotations
        setSummaryData(annotations)
    }, [props.annotationData]);

    return (
        <div className="px-10">
            <SummaryComponent lvid={props.lvid} data={summaryData} columns={columns} annotationData={props.annotationData}
                              setAnnotationData={props.setAnnotationData}/>
        </div>
    );
}

export default ShowSummaryComponent;
